import {
  getDocs,
  where,
  query,
  FieldPath,
  DocumentData,
  Query,
  QueryDocumentSnapshot,
  QueryConstraint,
  Timestamp,
} from 'firebase/firestore';
import { chunk } from 'functions/src/util/chunk';
import { Converter } from 'functions/src/util/firestore/Converter';

export type GetDocsInAllSettings<T extends DocumentData> = {
  query: Query;
  queryConstraints?: QueryConstraint[];
  where: [
    string | FieldPath,
    'in' | 'array-contains-any' | 'not-in',
    unknown[],
  ];
  converter?: Converter<T, Timestamp, Date>;
};

export async function getDocsInAll<T extends DocumentData>(
  settings: GetDocsInAllSettings<T>,
): Promise<QueryDocumentSnapshot<T>[]> {
  const querySnaps = await Promise.all(
    chunk(settings.where[2], 10).map(async (chunk) => {
      const queryUnconverted = query(
        settings.query,
        ...[
          ...(settings.queryConstraints || []),
          where(settings.where[0], settings.where[1], chunk),
        ],
      );
      const queryConverted = settings.converter
        ? queryUnconverted.withConverter(settings.converter)
        : (queryUnconverted as Query<T>);
      return await getDocs(queryConverted);
    }),
  );
  return querySnaps.reduce((prev, curr) => {
    prev.push(...curr.docs);
    return prev;
  }, [] as QueryDocumentSnapshot<T>[]);
}
